export default "__VITE_ASSET__f8adfd09__"